import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { fetchFrameGemaraOrder, fetchGemaraOrder } from '../mishtameretPortalApi';
import { EXAM_FRAMES } from '../nav';

/**
 * «הרשמה פעילה לקבלת כרך X לנבחני …» — בדף המבחנים ובראש המבחן, כמו ההודעה בטלפון בתחילת המבחן.
 * מוצג רק כשיש כרך פתוח במסגרת ולמי שעוד לא הזמין. frame — דף המבחנים; attemptId — בתוך מבחן.
 */
const GemaraOrderNotice = ({ frame, attemptId, theme }) => {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setOffer(null);
    const load = attemptId ? fetchGemaraOrder(attemptId) : fetchFrameGemaraOrder(frame);
    load
      .then((data) => { if (!cancelled) setOffer(data); })
      .catch(() => { /* בלי כרך פתוח / שגיאה — פשוט לא מציגים */ });
    return () => { cancelled = true; };
  }, [frame, attemptId]);

  if (!offer?.available || offer.ordered) return null;

  const frameLabel = EXAM_FRAMES.find((f) => f.id === frame)?.label;

  return (
    <Box
      sx={{
        bgcolor: theme.mode === 'light' ? 'rgba(168,134,74,0.08)' : 'rgba(212,175,122,0.1)',
        borderRadius: 2.5,
        border: `1px solid ${theme.accent}`,
        px: 2,
        py: 1.5,
        mb: 2,
      }}
    >
      <Typography sx={{ fontWeight: 700, color: theme.text }}>
        הרשמה פעילה לקבלת כרך {offer.campaign?.title}{frameLabel ? ` לנבחני ${frameLabel}` : ''}
      </Typography>
      <Typography sx={{ color: theme.textMuted, fontSize: '0.85rem', mt: 0.25 }}>
        ההרשמה בסיום המבחן.
      </Typography>
    </Box>
  );
};

export default GemaraOrderNotice;
